/* Use the existing product size-chart assets without leaving the buying guide. */
(() => {
  if (window.__pcBuyingGuideCharts) return;
  window.__pcBuyingGuideCharts = true;
  const initialized = new WeakSet();
  let pointerOpener;
  const clearPointerFocus = () => {
    pointerOpener?.removeAttribute('data-guide-pointer-focus');
    pointerOpener = null;
  };
  document.addEventListener('keydown', clearPointerFocus, true);

  function init(scope) {
    const dialog = scope.querySelector('.pc-guide-chart');
    if (!dialog || initialized.has(scope)) return;
    initialized.add(scope);
    const heading = dialog.querySelector('[data-guide-chart-heading]');
    const image = dialog.querySelector('[data-guide-chart-image]');
    const status = dialog.querySelector('[data-guide-chart-status]');
    const full = dialog.querySelector('[data-guide-chart-full]');
    const closeButton = dialog.querySelector('[data-guide-chart-close]');
    let opener, savedOverflow;

    image.addEventListener('load', () => {
      image.hidden = false;
      status.hidden = true;
    });
    image.addEventListener('error', () => {
      image.hidden = true;
      status.textContent = 'Die Tabelle konnte nicht geladen werden. Öffne sie über den Link unten.';
      status.hidden = false;
    });
    closeButton.addEventListener('click', () => dialog.close());
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      if (event.shiftKey && document.activeElement === closeButton) {
        event.preventDefault();
        full.focus();
      } else if (!event.shiftKey && document.activeElement === full) {
        event.preventDefault();
        closeButton.focus();
      }
    });
    dialog.addEventListener('click', (event) => {
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog &&
          (event.clientX < rect.left || event.clientX > rect.right ||
           event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = savedOverflow;
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    });
    scope.addEventListener('click', (event) => {
      const button = event.target.closest('[data-guide-chart-src]');
      if (!button || dialog.open) return;
      opener = button;
      clearPointerFocus();
      if (event.detail > 0) {
        pointerOpener = button;
        button.setAttribute('data-guide-pointer-focus', '');
      }
      heading.textContent = 'Größentabelle · ' + button.dataset.guideChartTitle;
      image.alt = 'Größentabelle für ' + button.dataset.guideChartTitle + ' mit Produktmaßen in Zentimetern.';
      image.hidden = true;
      status.textContent = 'Tabelle wird geladen …';
      status.hidden = false;
      full.href = button.dataset.guideChartSrc;
      image.src = button.dataset.guideChartSrc;
      savedOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
    });
    scope.querySelectorAll('[data-guide-chart-src]').forEach(button => { button.hidden = false; });
  }
  const boot = () => document.querySelectorAll('.pc-guide').forEach(init);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.pc-guide-chart[open]').forEach(dialog => dialog.close());
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
